import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { NavLink } from 'react-router-dom';
import './cookie-banner.scss';

const CookieBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Small delay so banner doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookie_consent', 'all');
    setVisible(false);
    // GA4 and GTM are already loaded, no action needed
  };

  const handleRejectNonEssential = () => {
    localStorage.setItem('cookie_consent', 'essential');
    setVisible(false);
    // Disable GA4
    window.gtag?.('consent', 'update', {
      analytics_storage: 'denied',
    });
  };

  if (!visible) return null;

  return (
    <Box className="cookie-banner">
      <Box className="cookie-banner-content">
        <Typography className="cookie-banner-text">
          Questo sito utilizza cookie tecnici necessari al funzionamento e cookie analitici di terze parti (Google Analytics) per migliorare l'esperienza di navigazione.
          Per maggiori informazioni consulta la nostra{' '}
          <NavLink to="/cookie-policy" className="cookie-banner-link">Cookie Policy</NavLink>
          {' '}e la{' '}
          <NavLink to="/privacy-policy" className="cookie-banner-link">Privacy Policy</NavLink>.
        </Typography>
        <Box className="cookie-banner-actions">
          <Button
            onClick={handleRejectNonEssential}
            className="cookie-btn cookie-btn-reject"
            variant="outlined"
          >
            Solo necessari
          </Button>
          <Button
            onClick={handleAcceptAll}
            className="cookie-btn cookie-btn-accept"
            variant="contained"
          >
            Accetta tutti
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

// Extend window for gtag
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export default CookieBanner;
